export default "__VITE_ASSET__CmGoYLzF__"